
<template>
  <div>
    <MemberHead />
    <div>
      <InteCard />
    </div>
  </div>
</template>
<script>
import { MemberHead, InteCard } from './components'
export default {
  components: {
    MemberHead,
    InteCard
  }
}
</script>